export function organizationCodeService(store) {

    let debounceTimer = null

    return {
        scheduleCheck(value) {

            clearTimeout(debounceTimer)

            debounceTimer = setTimeout(() => {
                this.check(value)
            }, 900)
        },

        async check(value) {
            const clean = value?.trim()

            if (!clean) return

            // mark pending
            store.serverValidation.organizationCode = {
                status: 'pending',
                data: null,
                lastCheckedValue: clean
            }

            const currentValue = clean
            const el = document.getElementById('app-uris')

            this.uris = el
                ? JSON.parse(el.textContent)
                : {}
            const uri =  this.uris.codeValidationUri  +`?id=${encodeURIComponent(clean)}`

            try {
                console.log('organizationCodeService : querying API', clean);
                const response = await fetch(
                    uri
                )

                // anti race condition
                if (store.values.organizationCode !== currentValue) {
                    return
                }

                if (response.status !== 200) {
                    store.serverValidation.organizationCode = {
                        status: 'server-error',
                        data: null,
                        lastCheckedValue: currentValue
                    }
                    return;
                }


                const data = await response.json()

                // anti race condition
                if (store.values.organizationCode !== currentValue) {
                    return
                }

                //console.log('organizationCodeService : data received', data);

                if ( data.success === undefined){
                    console.log('organizationCodeService : error querying API, unexpected format', data);
                    store.serverValidation.organizationCode = {
                        status: 'server-error',
                        data: null,
                        lastCheckedValue: currentValue
                    }
                    return;
                }

                if (data.hasOwnProperty('error')){
                    console.log('organizationCodeService : error querying API', data.error);
                    store.serverValidation.organizationCode = {
                        status: 'server-error',
                        data: null,
                        lastCheckedValue: currentValue
                    }
                    return;
                }

                if (data.success === false){

                    if (data.hasOwnProperty('failureCode') && data.failureCode === 'UNKNOWN_ORGANIZATION'){
                        store.serverValidation.organizationCode = {
                            status: 'not-found',
                            data: null,
                            lastCheckedValue: currentValue
                        }
                        return;
                    } else {
                        console.log('organizationCodeService : error querying API :', data);
                        store.serverValidation.organizationCode = {
                            status: 'server-error',
                            data: null,
                        }
                    }

                }

                if (data.success === true){
                    console.log('organizationCodeService : success querying API', data);
                    store.serverValidation.organizationCode = {
                        status:  'success',
                        data:  data,
                        lastCheckedValue: currentValue
                    }
                }



                /* if (!data.success) {
                     store.addError('organizationCode', 'invalid');
                 }*/

                if (store.setResolverOrganizationData === undefined) {
                    console.log('ERROR : organizationCodeService : setResolverOrganizationData is undefined');
                    console.log(JSON.stringify(store));
                    return;
                }
                store.setResolverOrganizationData(
                    {
                        "type" : data.organizationType ?? null,
                        "size" : data.organizationSize ?? null,
                        "activity" : data.organizationActivity ?? null,
                        "name" : data.organizationName ?? null
                    }
                )


            } catch (e) {
                console.error('organizationCodeService : error querying API', e);
                if (store.values.organizationCode !== currentValue) {
                    return
                }
                store.serverValidation.organizationCode = {
                    status: 'client-error',
                    data: null,
                    lastCheckedValue: currentValue
                }

            }
        }
    }
}
